import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { withRouter } from 'react-router-dom';
import * as Yup from 'yup';
import { Row } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { login } from 'redux/reducers/oauth/login';
import { toast } from 'react-toastify';
import SignUpComp from './SignUpComp';
import Loader from 'components/@vuexy/spinner/Fallback-spinner';
import {
  getCountries, signUp, getProgram, getSemesterByCourse, getApplicantSemester
} from 'redux/reducers/application/application';
import { CONSTANTS } from '../../../../constants';
import { loadCaptchaEnginge, validateCaptcha } from 'react-simple-captcha';

const SignUp = (props) => {
  const [captcha, setCaptcha] = useState('');
  const [captchaError, setCaptchaError] = useState('');

  useEffect(() => {
    window.localStorage.clear();
    loadCaptchaEnginge(6, '#9f9f9f');
    props.getProgram().catch(() => {
      toast.error('Failed to fetch Program List, Please try again!');
    });
    props.getCountries().catch(() => {
      toast.error('Failed to fetch country List, Please try again!');
    });
    props.getApplicantSemester({ isActive: true }).catch(() => {
      toast.error('Failed to fetch semester year List, Please try again!');
    });
    props.getSemesterByCourse(0).catch(() => {
      toast.error('Failed to fetch semester list, Please try Again');
    });
  }, []);

  const valiMsg = 'Please add country code along with phone number if it is less than 10 digits';
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().trim().required('First Name is required').nullable(),
    lastName: Yup.string().trim().required('Last Name is required').nullable(),
    country: Yup.object().required('Residence Country is required').nullable(),
    cellPhone: Yup.string()
      .when('country', {
        is: (country) => country?.id === CONSTANTS.ARUBA?.id,
        then: Yup.string()
          .matches(CONSTANTS.phoneValidation, valiMsg)
          .required(valiMsg),
        otherwise: Yup.string().trim().matches(CONSTANTS.phoneValidation, 'Please enter a valid phone number')
      })
      .required('Cell Phone is required')
      .nullable(),
    semesterYear: Yup.object().required('Semester Year is required').nullable(),
    program: Yup.object().required('Program is required').nullable(),
    semester: Yup.object().required('Semester Month is required').nullable(),
    email: Yup.string().trim().required('Email is required').nullable(),
    newPassword: Yup.string().required('Enter password').matches(CONSTANTS.passwordRegex, 'Password should contain atleast 1 Alphabet, number and special characters(@$!%*#?&_) with minimum of 8 characters').nullable(),
    confirmPassword: Yup.string().oneOf([Yup.ref('newPassword'), null], "Passwords don't match").required('Enter confirm password')
  });

  const successLogin = (data) => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    window.localStorage.setItem('userData', JSON.stringify(data));
    window.localStorage.setItem('isUserLogin', true);
    const otherviews = `/application/profile/${data.leadId}`;
    window.location.href = data.userDetail && data.userDetail.isForcePasswordChange ? '/reset-password' : otherviews;
  };
  const handleSubmit = (values) => {
    if (validateCaptcha(captcha, false)) {
      const data = {
        cellPhone: values.cellPhone ? `${(values.cellPhoneCode ? values.cellPhoneCode.replaceAll(/[^0-9]+/g, '') : '')}${values.cellPhone.replaceAll(/[^0-9]+/g, '')}` : undefined,
        confirmPassword: values.confirmPassword,
        country: values.country ? values.country.id : undefined,
        countryCode: values?.cellPhoneCode ? values.cellPhoneCode.replaceAll(/[^0-9]+/g, '') : null,
        email: values.email || undefined,
        firstName: values.firstName || undefined,
        gender: values.gender,
        lastName: values.lastName,
        password: values.newPassword,
        program: values.program?.id,
        semesterYear: values.semesterYear?.name,
        semesterType: values.semester?.name
      };
      props.signUp(data).then(() => {
        window.sessionStorage.setItem('userName', values.email);
        window.sessionStorage.setItem('password', values.newPassword);
        props.login(JSON.stringify({
          username: window.sessionStorage.getItem('userName', values.email).replaceAll(/\s+/g, ' ').trim(),
          password: window.sessionStorage.getItem('password', values.password).replaceAll(/\s+/g, ' ').trim(),
        })).then((res) => {
          successLogin(res);
        }).catch((err) => {
          toast.error(err.body && err.body.error_description, { toastId: err.body && err.body.error_description });
        });
      }).catch((err) => {
        toast.error(err.message || 'Failed to add Applicant, Please try Again');
      });
    } else {
      setCaptchaError('Captcha not matching');
    }
  };

  return (
    <>
      {(props.loading || props.loginLoading) && <Loader />}
      <Row className="justify-content-center align-items-center mx-0 pt-2 applicantBgImage vh-100">
        <Formik
          initialValues={{
            gender: 'm'
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(renderProps) => (
            <SignUpComp
              formProps={renderProps}
              country={props.countryList}
              captcha={captcha}
              setCaptcha={setCaptcha}
              captchaError={captchaError}
              setCaptchaError={setCaptchaError}
              program={props.program}
              semester={props.semester}
              semesterDetails={props.semesterDetails}
            />
          )}
        </Formik>
      </Row>
    </>
  );
};

const mapStateToProps = ({ application: { applicant }, oauth }) => ({
  countryList: applicant.countries,
  program: applicant.program,
  loading: applicant.loading,
  semester: applicant.getApplicantCTSemList,
  semesterDetails: applicant.getSemesterDetails,
  loginLoading: oauth?.login?.loading,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getCountries,
  signUp,
  getProgram,
  getApplicantSemester,
  getSemesterByCourse,
  login,
}, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SignUp)
);
